import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { NotificationProvider } from './components/ui/NotificationToast'
import { DirectionProvider } from './contexts/DirectionContext'
import './index.css'

// Initialize i18n and wait for it to be ready
import { i18nInitPromise } from './i18n'

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);

        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available
                console.log('New version available');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

// Loading fallback for Suspense (while translations load)
function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  )
}

// Wait for i18n to be initialized before rendering the app
i18nInitPromise.then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Suspense fallback={<LoadingFallback />}>
        <BrowserRouter>
          <DirectionProvider>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </DirectionProvider>
        </BrowserRouter>
      </Suspense>
    </React.StrictMode>,
  )
})
